(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.raf = null;

      // floating animation config
      this.floatStart = 100;
      this.floatEnd = 250;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // Detect floating mode ONLY for the floating menu type
      this.isFloatingMenu = this.classList.contains('header-wrapper--floating');
      if (this.isFloatingMenu) {
        // Read merchant settings from dataset (set on the sticky-header tag above)
        this.floatingWidth = parseFloat(this.dataset.floatingWidth || '90'); // percent
        this.floatingRadius = parseFloat(this.dataset.floatingRadius || '0'); // px
      }

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', () => {
        if (!this.isFloatingMenu) return;
        // Force a recalculation of inline px widths on resize
        this.updateFloatingStyles();
      }, { passive: true });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();

      // Initial update for floating mode
      if (this.isFloatingMenu) {
        this.updateFloatingStyles();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    clamp(n, min, max) {
      return Math.min(max, Math.max(min, n));
    }

    lerp(a, b, t) {
      return a + (b - a) * t;
    }

    // Parses a CSS length like "120rem" or "1280px" into px
    toPx(value, rootFontPx) {
      if (!value) return 0;
      const v = String(value).trim();
      const num = parseFloat(v);
      if (Number.isNaN(num)) return 0;
      if (v.endsWith('rem')) return num * rootFontPx;
      if (v.endsWith('px')) return num;
      // fallback: treat unitless as px
      return num;
    }

    updateFloatingStyles() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Progress: 0 until 100px, 1 at 250px
      const range = Math.max(1, this.floatEnd - this.floatStart);
      const p = this.clamp((scrollTop - this.floatStart) / range, 0, 1);

      // Before the start: behave like normal header (no fixed positioning, no placeholder)
      if (p === 0) {
        this.classList.remove('is-floating');
        this.header.classList.remove('floating-placeholder');

        this.style.width = '';
        this.style.top = '';
        this.style.borderRadius = '';
        return;
      }

      // Activate floating: fixed positioning + placeholder to prevent overlap
      this.classList.add('is-floating');
      this.header.classList.add('floating-placeholder');

      const rootFont = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

      // Read --page-width and convert to px (Dawn uses rem)
      const pageWidthRaw = getComputedStyle(document.documentElement).getPropertyValue('--page-width').trim(); // e.g. "120rem"
      const pageWidthPx = this.toPx(pageWidthRaw, rootFont) || 120 * rootFont;

      // Start width: full viewport width
      const startWidthPx = window.innerWidth;

      // Target width: merchant % of viewport, but never exceed page width
      const targetWidthPx = Math.min(pageWidthPx, window.innerWidth * (this.floatingWidth / 100));

      // Animate width smoothly in px
      const widthPx = this.lerp(startWidthPx, targetWidthPx, p);

      // Animate top (0 -> 1rem)
      const topPx = this.lerp(0, rootFont * 1, p);

      // Animate radius (0 -> merchant radius)
      const radiusPx = this.lerp(0, this.floatingRadius, p);

      this.style.width = `${widthPx}px`;
      this.style.top = `${topPx}px`;
      this.style.borderRadius = `${radiusPx}px`;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Keep Dawn's sticky logic intact for ALL menu types (unchanged)
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      // Floating animation only for floating menu type, throttled by rAF
      if (this.isFloatingMenu) {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.updateFloatingStyles();
        });
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
